import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";

const Collections = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch products from API
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await fetch("/api/products");
        const data = await res.json();
        setProducts(data.products || []);
      } catch (error) {
        console.error("Failed to fetch products:", error);
        toast.error("Failed to load products. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) {
    return <p className="text-center mt-10">Loading collections...</p>;
  }

  // Group products by collectionName
  const groupedCollections = Object.values(
    products.reduce((acc, product) => {
      if (!acc[product.collectionName]) {
        acc[product.collectionName] = { name: product.collectionName, products: [] };
      }
      acc[product.collectionName].products.push(product);
      return acc;
    }, {})
  );

  return (
    <section className="pt-[65px] poppins pb-[20px] px-4 lg:px-[150px]">
      <div className="container mx-auto">
        {groupedCollections.map((collection, index) => (
          <div key={index} className="mb-12">
            {/* Collection Products */}
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-6">
              {collection.products.slice(0, 7).map((product) => {
                const img = product.variants?.[0]?.images?.[0]?.src || "/placeholder.jpg";
                const price = product.price;

                return (
                  <div
                    key={product._id}
                    onClick={() => navigate(`/product/${product._id}`, { state: { product } })}
                    className="flex flex-col items-center text-center cursor-pointer"
                  >
                    <div className="w-full max-w-[260px] rounded-2xl overflow-hidden shadow hover:shadow-lg transition-transform transform hover:-translate-y-1">
                      <img
                        src={img}
                        alt={product.model}
                        className="w-full h-[180px] md:h-[250px] object-cover transition-transform duration-500 ease-in-out hover:scale-105"
                      />
                    </div>
                    <p className="text-sm font-semibold mt-2">{product.model}</p>
                    {product.sale?.isOnSale ? (
                      <div className="flex flex-col items-center">
                        <span className="text-red-500 font-bold">
                          {product.sale.finalPrice.toLocaleString()} DT
                        </span>
                        <span className="text-gray-400 text-xs line-through">
                          {product.price.toLocaleString()} DT
                        </span>
                      </div>
                    ) : (
                      <span className="text-gray-500 text-xs">
                        {(product.sale?.finalPrice || product.price).toLocaleString()} DT
                      </span>
                    )}
                  </div>
                );
              })}
            </div>

            {/* View All */}
            <div className="flex justify-end mt-6">
              <Link
                to={`/allproducts?category=${collection.name}`}
                className="bg-black hover:bg-orange-500 text-white px-6 py-2 rounded-md transition"
              >
                View All
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Collections;
